import { readonly, ref } from 'vue'
import type { Ref } from 'vue'

interface LegacyLoadingPort {
    state: Readonly<Ref<boolean>>
    set: (value: boolean) => void
}

const fallback = ref(false)
let port: LegacyLoadingPort = {
    state: readonly(fallback),
    set: (value) => {
        fallback.value = value
    },
}

/** App bridge for the single legacy uiStore.isLoading boolean shared by every route. */
export function configureLegacyLoading(next: LegacyLoadingPort): void {
    port = next
}

export function useLegacyLoading(): LegacyLoadingPort {
    return {
        get state() {
            return port.state
        },
        set: (value) => port.set(value),
    }
}
